import 'jquery-ajax-unobtrusive';
import '../../../scss/sites/citylens/citylens-style.scss';
import Bookingmask from '@png/npm-bookingmask';
import Header from '@png/npm-header';
import Iibe from '@png/npm-iibe';
import SelectDropdown from '@png/npm-select-dropdown';
import SvgIcon from '@png/npm-svg-icon';
import AddressLookup from '../../modules/address-lookup';
import ClearCache from '../../modules/clear-cache';
// import CookieBar from '../../modules/cookie-bar';
import Incrementer from '../../modules/incrementer';
import LightGallery from '../../modules/light-gallery';
import Pagination from '../../modules/pagination';
import Sticky from '../../modules/sticky';
import Video from '../../modules/video';
import Toast from '../../modules/toast';
import SmoothScroll from '../../modules/smooth-scroll';

document.addEventListener('DOMContentLoaded', () => {
  const modules = [
    new AddressLookup(),
    new Bookingmask({
      displayFormat: 'd/m/Y',
      dateFormat: 'Y-m-d',
      datepickerType: 'separate',
      disableMobile: false
    }),
    new ClearCache(),
    // new CookieBar(),
    new Header({
      desktopMenuBreakpoint: 992,
      openUrlOnToggle: false
    }),
    new Iibe(),
    new Incrementer(),
    new LightGallery(),
    new Pagination(),
    new SelectDropdown(),
    new Sticky({
      velocity: 200
    }),
    new SvgIcon(),
    new Toast({
      duration: 3000,
      close: true
    }),
    new SmoothScroll(),
    new Video()
  ];

  modules.forEach(module => {
    if (module && module.init) {
      module.init();
    }
  });
});
